import { customScrollMinimal, Icon, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const MainContent = styled.main`
  display: flex;
  flex-direction: column;
  height: fit-content;
  align-items: center;
  max-height: 100%;
  width: 100%;
`;

export const ChatView = styled.div`
  ${customScrollMinimal};
  flex: 1;
  flex-direction: column;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
  overflow: scroll;
  padding: 16px 0 var(--chat-footer-height) 10px;
  scroll-behavior: smooth;
`;

export const ChatWrapper = styled.section<{ $hasMessage: boolean }>`
  display: flex;
  flex-direction: column;
  position: fixed;
  align-items: center;
  justify-content: center;
  bottom: 50%;
  z-index: 1;
  transition: bottom 0.3s ease-in-out;
  ${({ $hasMessage }) =>
    $hasMessage &&
    css`
      bottom: 16px;
    `}
`;

export const EmptyContainer = styled.section`
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: center;
  bottom: 16px;
  z-index: 1;
`;

export const Title = styled.h1`
  ${typographyV2.titleXL};
  padding-bottom: 24px;
`;

export const AlfredIcon = styled(Icon)`
  fill: var(--icon-primary);
  margin-bottom: 8px;
`;
